module.exports = __webpack_public_path__ + "static/media/cafe24-data.19440a52.png";